module.exports = __webpack_public_path__ + "img/17.ba25a563.png";